import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import { IconButton, Paper, Stack } from "@mui/material"

import { FC, ReactNode } from "react"
import { uiSurface, UiSurfaceId } from "shared/ui/uiSurface"

interface HorizontalCollapsiblePaperProps {
  collapsedWidth: number
  expandedWidth: number
  children: ReactNode
  expanded?: boolean
  handleToggle?: any
  customHeader?: ReactNode
  ui?: UiSurfaceId
}

export const HorizontalCollapsiblePaper: FC<
  HorizontalCollapsiblePaperProps
> = ({
  expanded,
  handleToggle,
  collapsedWidth,
  expandedWidth,
  children,
  customHeader = null,
  ui,
}) => {
  return (
    <Paper
      {...(ui && uiSurface(ui))}
      elevation={0}
      sx={(theme) => ({
        position: "relative",
        top: 0,
        right: 0,
        width: expanded ? expandedWidth : collapsedWidth,
        height: "100%",
        transition: "width 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        borderRadius: 3,
        padding: 1.5,
        overflow: "hidden",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      })}
    >
      {customHeader ? (
        customHeader
      ) : (
        <Stack direction={"row"} justifyContent={"space-between"}>
          <IconButton
            data-testid="collapsible-toggle-btn"
            size="small"
            sx={(theme) => ({
              marginLeft: "auto",
              border: `1px solid ${theme.palette.divider}`,
              "&:hover": {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.primary.light,
              },
            })}
            onClick={handleToggle}
          >
            {expanded ? <ChevronRight fontSize="small" /> : <ChevronLeft fontSize="small" />}
          </IconButton>
        </Stack>
      )}
      {children}
    </Paper>
  )
}
